import { Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { bool_type, record_type, tuple_type, int32_type, lambda_type, class_type, union_type, string_type, array_type, unit_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { TrackLevel_$reflection, UpdatedTask_$reflection, NewTask_$reflection, Task_$reflection, UpdateCourse_$reflection, NewCourse_$reflection, Course_$reflection, TrackLevelCourse_$reflection, NewTrack_$reflection, Track_$reflection, EventAttendee_$reflection, UpdatedEvent_$reflection, NewEvent_$reflection, Event$_$reflection, UpdatedWorkplace_$reflection, NewWorkplace_$reflection, Workplace_$reflection, NewRegion_$reflection, Region_$reflection, Session_$reflection, S3UploadFile_$reflection, UpdatedUser_$reflection, User_$reflection, AuditLog_$reflection } from "./SharedModels.jsx";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";

export class IAuditApi extends Record {
    constructor(GetAllAuditLogs, GetFromTable, GetFromTableRow) {
        super();
        this.GetAllAuditLogs = GetAllAuditLogs;
        this.GetFromTable = GetFromTable;
        this.GetFromTableRow = GetFromTableRow;
    }
}

export function IAuditApi_$reflection() {
    return record_type("Shared.Api.IAuditApi", [], IAuditApi, () => [["GetAllAuditLogs", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(AuditLog_$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", array_type(AuditLog_$reflection())]], [["ErrorValue", string_type]]])]))], ["GetFromTable", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(AuditLog_$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", array_type(AuditLog_$reflection())]], [["ErrorValue", string_type]]])]))], ["GetFromTableRow", lambda_type(tuple_type(string_type, int32_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(AuditLog_$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", array_type(AuditLog_$reflection())]], [["ErrorValue", string_type]]])]))]]);
}

export class GetUserError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function GetUserError_$reflection() {
    return union_type("Shared.Api.GetUserError", [], GetUserError, () => [[]]);
}

export class UpdateUserError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UserNotFound", "WorkplaceNotFound", "InvalidName"];
    }
}

export function UpdateUserError_$reflection() {
    return union_type("Shared.Api.UpdateUserError", [], UpdateUserError, () => [[], [], []]);
}

export class UpdateProfilePictureError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "S3UploadError"];
    }
}

export function UpdateProfilePictureError_$reflection() {
    return union_type("Shared.Api.UpdateProfilePictureError", [], UpdateProfilePictureError, () => [[], []]);
}

export class UpdateEnabledStateError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "MissingWorkplace", "IsAdmin"];
    }
}

export function UpdateEnabledStateError_$reflection() {
    return union_type("Shared.Api.UpdateEnabledStateError", [], UpdateEnabledStateError, () => [[], [], []]);
}

export class IUserApi extends Record {
    constructor(GetUser, GetAll, UpdateUser, UpdateProfilePicture, GetSession) {
        super();
        this.GetUser = GetUser;
        this.GetAll = GetAll;
        this.UpdateUser = UpdateUser;
        this.UpdateProfilePicture = UpdateProfilePicture;
        this.GetSession = GetSession;
    }
}

export function IUserApi_$reflection() {
    return record_type("Shared.Api.IUserApi", [], IUserApi, () => [["GetUser", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [User_$reflection(), GetUserError_$reflection()], FSharpResult$2, () => [[["ResultValue", User_$reflection()]], [["ErrorValue", GetUserError_$reflection()]]])]))], ["GetAll", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(User_$reflection()), GetUserError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(User_$reflection())]], [["ErrorValue", GetUserError_$reflection()]]])]))], ["UpdateUser", lambda_type(int32_type, lambda_type(UpdatedUser_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [User_$reflection(), UpdateUserError_$reflection()], FSharpResult$2, () => [[["ResultValue", User_$reflection()]], [["ErrorValue", UpdateUserError_$reflection()]]])])))], ["UpdateProfilePicture", lambda_type(S3UploadFile_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, UpdateProfilePictureError_$reflection()], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", UpdateProfilePictureError_$reflection()]]])]))], ["GetSession", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Session_$reflection(), GetUserError_$reflection()], FSharpResult$2, () => [[["ResultValue", Session_$reflection()]], [["ErrorValue", GetUserError_$reflection()]]])]))]]);
}

export class GetRegionError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function GetRegionError_$reflection() {
    return union_type("Shared.Api.GetRegionError", [], GetRegionError, () => [[]]);
}

export class AddRegionError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["Conflict"];
    }
}

export function AddRegionError_$reflection() {
    return union_type("Shared.Api.AddRegionError", [], AddRegionError, () => [[]]);
}

export class UpdateRegionError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "Conflict"];
    }
}

export function UpdateRegionError_$reflection() {
    return union_type("Shared.Api.UpdateRegionError", [], UpdateRegionError, () => [[], []]);
}

export class DeleteRegionError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "HasWorkplaces"];
    }
}

export function DeleteRegionError_$reflection() {
    return union_type("Shared.Api.DeleteRegionError", [], DeleteRegionError, () => [[], []]);
}

export class IRegionApi extends Record {
    constructor(GetRegion, GetAllRegions, GetEnabledRegions, AddRegion, UpdateRegion, DeleteRegion) {
        super();
        this.GetRegion = GetRegion;
        this.GetAllRegions = GetAllRegions;
        this.GetEnabledRegions = GetEnabledRegions;
        this.AddRegion = AddRegion;
        this.UpdateRegion = UpdateRegion;
        this.DeleteRegion = DeleteRegion;
    }
}

export function IRegionApi_$reflection() {
    return record_type("Shared.Api.IRegionApi", [], IRegionApi, () => [["GetRegion", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Region_$reflection(), GetRegionError_$reflection()], FSharpResult$2, () => [[["ResultValue", Region_$reflection()]], [["ErrorValue", GetRegionError_$reflection()]]])]))], ["GetAllRegions", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Region_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(Region_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetEnabledRegions", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Region_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(Region_$reflection())]], [["ErrorValue", unit_type]]])]))], ["AddRegion", lambda_type(NewRegion_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Region_$reflection(), AddRegionError_$reflection()], FSharpResult$2, () => [[["ResultValue", Region_$reflection()]], [["ErrorValue", AddRegionError_$reflection()]]])]))], ["UpdateRegion", lambda_type(Region_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Region_$reflection(), UpdateRegionError_$reflection()], FSharpResult$2, () => [[["ResultValue", Region_$reflection()]], [["ErrorValue", UpdateRegionError_$reflection()]]])]))], ["DeleteRegion", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, DeleteRegionError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", DeleteRegionError_$reflection()]]])]))]]);
}

export class GetWorkplaceError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function GetWorkplaceError_$reflection() {
    return union_type("Shared.Api.GetWorkplaceError", [], GetWorkplaceError, () => [[]]);
}

export class AddWorkplaceError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["RegionNotFound", "Conflict"];
    }
}

export function AddWorkplaceError_$reflection() {
    return union_type("Shared.Api.AddWorkplaceError", [], AddWorkplaceError, () => [[], []]);
}

export class UpdateWorkplaceError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["RegionNotFound", "WorkplaceNotFound", "Conflict"];
    }
}

export function UpdateWorkplaceError_$reflection() {
    return union_type("Shared.Api.UpdateWorkplaceError", [], UpdateWorkplaceError, () => [[], [], []]);
}

export class DeleteWorkplaceError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "HasUsers"];
    }
}

export function DeleteWorkplaceError_$reflection() {
    return union_type("Shared.Api.DeleteWorkplaceError", [], DeleteWorkplaceError, () => [[], []]);
}

export class IWorkplaceApi extends Record {
    constructor(GetWorkplace, GetWorkplacesByRegion, GetEnabledWorkplacesByRegion, GetAllWorkplaces, GetEnabledWorkplaces, AddWorkplace, UpdateWorkplace, DeleteWorkplace) {
        super();
        this.GetWorkplace = GetWorkplace;
        this.GetWorkplacesByRegion = GetWorkplacesByRegion;
        this.GetEnabledWorkplacesByRegion = GetEnabledWorkplacesByRegion;
        this.GetAllWorkplaces = GetAllWorkplaces;
        this.GetEnabledWorkplaces = GetEnabledWorkplaces;
        this.AddWorkplace = AddWorkplace;
        this.UpdateWorkplace = UpdateWorkplace;
        this.DeleteWorkplace = DeleteWorkplace;
    }
}

export function IWorkplaceApi_$reflection() {
    return record_type("Shared.Api.IWorkplaceApi", [], IWorkplaceApi, () => [["GetWorkplace", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Workplace_$reflection(), GetWorkplaceError_$reflection()], FSharpResult$2, () => [[["ResultValue", Workplace_$reflection()]], [["ErrorValue", GetWorkplaceError_$reflection()]]])]))], ["GetWorkplacesByRegion", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Workplace_$reflection()), GetWorkplaceError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Workplace_$reflection())]], [["ErrorValue", GetWorkplaceError_$reflection()]]])]))], ["GetEnabledWorkplacesByRegion", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Workplace_$reflection()), GetWorkplaceError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Workplace_$reflection())]], [["ErrorValue", GetWorkplaceError_$reflection()]]])]))], ["GetAllWorkplaces", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Workplace_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(Workplace_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetEnabledWorkplaces", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Workplace_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(Workplace_$reflection())]], [["ErrorValue", unit_type]]])]))], ["AddWorkplace", lambda_type(NewWorkplace_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Workplace_$reflection(), AddWorkplaceError_$reflection()], FSharpResult$2, () => [[["ResultValue", Workplace_$reflection()]], [["ErrorValue", AddWorkplaceError_$reflection()]]])]))], ["UpdateWorkplace", lambda_type(UpdatedWorkplace_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Workplace_$reflection(), UpdateWorkplaceError_$reflection()], FSharpResult$2, () => [[["ResultValue", Workplace_$reflection()]], [["ErrorValue", UpdateWorkplaceError_$reflection()]]])]))], ["DeleteWorkplace", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, DeleteWorkplaceError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", DeleteWorkplaceError_$reflection()]]])]))]]);
}

export class GetEventError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function GetEventError_$reflection() {
    return union_type("Shared.Api.GetEventError", [], GetEventError, () => [[]]);
}

export class AddEventError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NegativeMaxAttendees", "EmptyName", "EmptySummary", "EmptyAddress", "InvalidTeacher", "InvalidCourse", "InvalidRegion"];
    }
}

export function AddEventError_$reflection() {
    return union_type("Shared.Api.AddEventError", [], AddEventError, () => [[], [], [], [], [], [], []]);
}

export class UpdateEventError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "NegativeMaxAttendees"];
    }
}

export function UpdateEventError_$reflection() {
    return union_type("Shared.Api.UpdateEventError", [], UpdateEventError, () => [[], []]);
}

export class GetEventAttendeesError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function GetEventAttendeesError_$reflection() {
    return union_type("Shared.Api.GetEventAttendeesError", [], GetEventAttendeesError, () => [[]]);
}

export class GetEventAttendeeCountError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function GetEventAttendeeCountError_$reflection() {
    return union_type("Shared.Api.GetEventAttendeeCountError", [], GetEventAttendeeCountError, () => [[]]);
}

export class CheckOwnEventAttendanceError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function CheckOwnEventAttendanceError_$reflection() {
    return union_type("Shared.Api.CheckOwnEventAttendanceError", [], CheckOwnEventAttendanceError, () => [[]]);
}

export class SignUpForEventError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function SignUpForEventError_$reflection() {
    return union_type("Shared.Api.SignUpForEventError", [], SignUpForEventError, () => [[]]);
}

export class RemoveEventAttendeeError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["EventNotFound", "UserNotFound", "UserNotAttending"];
    }
}

export function RemoveEventAttendeeError_$reflection() {
    return union_type("Shared.Api.RemoveEventAttendeeError", [], RemoveEventAttendeeError, () => [[], [], []]);
}

export class IEventApi extends Record {
    constructor(Get, GetAll, GetEnabled, GetMy, GetTaughtBy, GetFromCourse, GetEnabledFromCourse, Add, Update, GetAttendees, CheckOwnAttendance, SignUp, Withdraw, RemoveAttendee) {
        super();
        this.Get = Get;
        this.GetAll = GetAll;
        this.GetEnabled = GetEnabled;
        this.GetMy = GetMy;
        this.GetTaughtBy = GetTaughtBy;
        this.GetFromCourse = GetFromCourse;
        this.GetEnabledFromCourse = GetEnabledFromCourse;
        this.Add = Add;
        this.Update = Update;
        this.GetAttendees = GetAttendees;
        this.CheckOwnAttendance = CheckOwnAttendance;
        this.SignUp = SignUp;
        this.Withdraw = Withdraw;
        this.RemoveAttendee = RemoveAttendee;
    }
}

export function IEventApi_$reflection() {
    return record_type("Shared.Api.IEventApi", [], IEventApi, () => [["Get", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Event$_$reflection(), GetEventError_$reflection()], FSharpResult$2, () => [[["ResultValue", Event$_$reflection()]], [["ErrorValue", GetEventError_$reflection()]]])]))], ["GetAll", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Event$_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(Event$_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetEnabled", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Event$_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(Event$_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetMy", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Event$_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(Event$_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetTaughtBy", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Event$_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(Event$_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetFromCourse", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Event$_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(Event$_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetEnabledFromCourse", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Event$_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(Event$_$reflection())]], [["ErrorValue", unit_type]]])]))], ["Add", lambda_type(NewEvent_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Event$_$reflection(), AddEventError_$reflection()], FSharpResult$2, () => [[["ResultValue", Event$_$reflection()]], [["ErrorValue", AddEventError_$reflection()]]])]))], ["Update", lambda_type(int32_type, lambda_type(UpdatedEvent_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Event$_$reflection(), UpdateEventError_$reflection()], FSharpResult$2, () => [[["ResultValue", Event$_$reflection()]], [["ErrorValue", UpdateEventError_$reflection()]]])])))], ["GetAttendees", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(EventAttendee_$reflection()), GetEventAttendeesError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(EventAttendee_$reflection())]], [["ErrorValue", GetEventAttendeesError_$reflection()]]])]))], ["CheckOwnAttendance", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [bool_type, CheckOwnEventAttendanceError_$reflection()], FSharpResult$2, () => [[["ResultValue", bool_type]], [["ErrorValue", CheckOwnEventAttendanceError_$reflection()]]])]))], ["SignUp", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, SignUpForEventError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", SignUpForEventError_$reflection()]]])]))], ["Withdraw", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, RemoveEventAttendeeError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", RemoveEventAttendeeError_$reflection()]]])]))], ["RemoveAttendee", lambda_type(int32_type, lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, RemoveEventAttendeeError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", RemoveEventAttendeeError_$reflection()]]])])))]]);
}

export class GetTrackError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function GetTrackError_$reflection() {
    return union_type("Shared.Api.GetTrackError", [], GetTrackError, () => [[]]);
}

export class AddTrackError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Conflict", "ValidationFailed", "UploadImageError"];
    }
}

export function AddTrackError_$reflection() {
    return union_type("Shared.Api.AddTrackError", [], AddTrackError, () => [[], [], []]);
}

export class UpdateTrackError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Conflict", "NotFound"];
    }
}

export function UpdateTrackError_$reflection() {
    return union_type("Shared.Api.UpdateTrackError", [], UpdateTrackError, () => [[], []]);
}

export class DeleteTrackError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "RelationsExist"];
    }
}

export function DeleteTrackError_$reflection() {
    return union_type("Shared.Api.DeleteTrackError", [], DeleteTrackError, () => [[], []]);
}

export class SignUpForTrackError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "TrackDisabled", "AlreadySignedUp"];
    }
}

export function SignUpForTrackError_$reflection() {
    return union_type("Shared.Api.SignUpForTrackError", [], SignUpForTrackError, () => [[], [], []]);
}

export class ITrackApi extends Record {
    constructor(GetAll, GetAllEnabled, GetMy, Get, Add, Update, Delete, SignUp) {
        super();
        this.GetAll = GetAll;
        this.GetAllEnabled = GetAllEnabled;
        this.GetMy = GetMy;
        this.Get = Get;
        this.Add = Add;
        this.Update = Update;
        this.Delete = Delete;
        this.SignUp = SignUp;
    }
}

export function ITrackApi_$reflection() {
    return record_type("Shared.Api.ITrackApi", [], ITrackApi, () => [["GetAll", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Track_$reflection()), GetTrackError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Track_$reflection())]], [["ErrorValue", GetTrackError_$reflection()]]])]))], ["GetAllEnabled", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Track_$reflection()), GetTrackError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Track_$reflection())]], [["ErrorValue", GetTrackError_$reflection()]]])]))], ["GetMy", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Track_$reflection()), GetTrackError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Track_$reflection())]], [["ErrorValue", GetTrackError_$reflection()]]])]))], ["Get", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Track_$reflection(), GetTrackError_$reflection()], FSharpResult$2, () => [[["ResultValue", Track_$reflection()]], [["ErrorValue", GetTrackError_$reflection()]]])]))], ["Add", lambda_type(NewTrack_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Track_$reflection(), AddTrackError_$reflection()], FSharpResult$2, () => [[["ResultValue", Track_$reflection()]], [["ErrorValue", AddTrackError_$reflection()]]])]))], ["Update", lambda_type(Track_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Track_$reflection(), UpdateTrackError_$reflection()], FSharpResult$2, () => [[["ResultValue", Track_$reflection()]], [["ErrorValue", UpdateTrackError_$reflection()]]])]))], ["Delete", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, DeleteTrackError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", DeleteTrackError_$reflection()]]])]))], ["SignUp", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, SignUpForTrackError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", SignUpForTrackError_$reflection()]]])]))]]);
}

export class AddTrackLevelCourseError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Conflict", "NotFound"];
    }
}

export function AddTrackLevelCourseError_$reflection() {
    return union_type("Shared.Api.AddTrackLevelCourseError", [], AddTrackLevelCourseError, () => [[], []]);
}

export class UpdateTrackLevelCourseError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function UpdateTrackLevelCourseError_$reflection() {
    return union_type("Shared.Api.UpdateTrackLevelCourseError", [], UpdateTrackLevelCourseError, () => [[]]);
}

export class DeleteTrackLevelCourseError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "RelationsExist"];
    }
}

export function DeleteTrackLevelCourseError_$reflection() {
    return union_type("Shared.Api.DeleteTrackLevelCourseError", [], DeleteTrackLevelCourseError, () => [[], []]);
}

export class NewTrackLevelCourse extends Record {
    constructor(TrackLevelId, CourseId) {
        super();
        this.TrackLevelId = (TrackLevelId | 0);
        this.CourseId = (CourseId | 0);
    }
}

export function NewTrackLevelCourse_$reflection() {
    return record_type("Shared.Api.NewTrackLevelCourse", [], NewTrackLevelCourse, () => [["TrackLevelId", int32_type], ["CourseId", int32_type]]);
}

export class ITrackLevelCourseApi extends Record {
    constructor(Add, UpdateOrder, Delete) {
        super();
        this.Add = Add;
        this.UpdateOrder = UpdateOrder;
        this.Delete = Delete;
    }
}

export function ITrackLevelCourseApi_$reflection() {
    return record_type("Shared.Api.ITrackLevelCourseApi", [], ITrackLevelCourseApi, () => [["Add", lambda_type(NewTrackLevelCourse_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [TrackLevelCourse_$reflection(), AddTrackLevelCourseError_$reflection()], FSharpResult$2, () => [[["ResultValue", TrackLevelCourse_$reflection()]], [["ErrorValue", AddTrackLevelCourseError_$reflection()]]])]))], ["UpdateOrder", lambda_type(tuple_type(int32_type, int32_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, UpdateTrackLevelCourseError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", UpdateTrackLevelCourseError_$reflection()]]])]))], ["Delete", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, DeleteTrackLevelCourseError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", DeleteTrackLevelCourseError_$reflection()]]])]))]]);
}

export class CourseError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "Conflict", "RelationsExist"];
    }
}

export function CourseError_$reflection() {
    return union_type("Shared.Api.CourseError", [], CourseError, () => [[], [], []]);
}

export class AddCourseError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Conflict", "UploadImageError"];
    }
}

export function AddCourseError_$reflection() {
    return union_type("Shared.Api.AddCourseError", [], AddCourseError, () => [[], []]);
}

export class UpdateCourseError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "ValidationFailed", "ImageUploadFailed", "Conflict"];
    }
}

export function UpdateCourseError_$reflection() {
    return union_type("Shared.Api.UpdateCourseError", [], UpdateCourseError, () => [[], [], [], []]);
}

export class AddCourseTaskError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "Conflict"];
    }
}

export function AddCourseTaskError_$reflection() {
    return union_type("Shared.Api.AddCourseTaskError", [], AddCourseTaskError, () => [[], []]);
}

export class DeleteCourseTaskError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function DeleteCourseTaskError_$reflection() {
    return union_type("Shared.Api.DeleteCourseTaskError", [], DeleteCourseTaskError, () => [[]]);
}

export class AddNewCourseTaskError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "Conflict"];
    }
}

export function AddNewCourseTaskError_$reflection() {
    return union_type("Shared.Api.AddNewCourseTaskError", [], AddNewCourseTaskError, () => [[], []]);
}

export class ICourseApi extends Record {
    constructor(GetAllCourses, GetCourse, CheckOwnEligibility, CheckUserEligibility, AddCourse, UpdateCourse, DeleteCourse, AddCourseTask, DeleteCourseTask, AddNewCourseTask) {
        super();
        this.GetAllCourses = GetAllCourses;
        this.GetCourse = GetCourse;
        this.CheckOwnEligibility = CheckOwnEligibility;
        this.CheckUserEligibility = CheckUserEligibility;
        this.AddCourse = AddCourse;
        this.UpdateCourse = UpdateCourse;
        this.DeleteCourse = DeleteCourse;
        this.AddCourseTask = AddCourseTask;
        this.DeleteCourseTask = DeleteCourseTask;
        this.AddNewCourseTask = AddNewCourseTask;
    }
}

export function ICourseApi_$reflection() {
    return record_type("Shared.Api.ICourseApi", [], ICourseApi, () => [["GetAllCourses", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Course_$reflection()), CourseError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Course_$reflection())]], [["ErrorValue", CourseError_$reflection()]]])]))], ["GetCourse", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Course_$reflection(), CourseError_$reflection()], FSharpResult$2, () => [[["ResultValue", Course_$reflection()]], [["ErrorValue", CourseError_$reflection()]]])]))], ["CheckOwnEligibility", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [bool_type, unit_type], FSharpResult$2, () => [[["ResultValue", bool_type]], [["ErrorValue", unit_type]]])]))], ["CheckUserEligibility", lambda_type(int32_type, lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [bool_type, unit_type], FSharpResult$2, () => [[["ResultValue", bool_type]], [["ErrorValue", unit_type]]])])))], ["AddCourse", lambda_type(NewCourse_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Course_$reflection(), AddCourseError_$reflection()], FSharpResult$2, () => [[["ResultValue", Course_$reflection()]], [["ErrorValue", AddCourseError_$reflection()]]])]))], ["UpdateCourse", lambda_type(UpdateCourse_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Course_$reflection(), UpdateCourseError_$reflection()], FSharpResult$2, () => [[["ResultValue", Course_$reflection()]], [["ErrorValue", UpdateCourseError_$reflection()]]])]))], ["DeleteCourse", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, CourseError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", CourseError_$reflection()]]])]))], ["AddCourseTask", lambda_type(int32_type, lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Task_$reflection(), AddCourseTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", Task_$reflection()]], [["ErrorValue", AddCourseTaskError_$reflection()]]])])))], ["DeleteCourseTask", lambda_type(int32_type, lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Task_$reflection(), DeleteCourseTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", Task_$reflection()]], [["ErrorValue", DeleteCourseTaskError_$reflection()]]])])))], ["AddNewCourseTask", lambda_type(int32_type, lambda_type(NewTask_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Task_$reflection(), AddNewCourseTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", Task_$reflection()]], [["ErrorValue", AddNewCourseTaskError_$reflection()]]])])))]]);
}

export class GetTaskError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function GetTaskError_$reflection() {
    return union_type("Shared.Api.GetTaskError", [], GetTaskError, () => [[]]);
}

export class AddTaskError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["Conflict"];
    }
}

export function AddTaskError_$reflection() {
    return union_type("Shared.Api.AddTaskError", [], AddTaskError, () => [[]]);
}

export class UpdateTaskError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Conflict", "NotFound", "EmptyFields"];
    }
}

export function UpdateTaskError_$reflection() {
    return union_type("Shared.Api.UpdateTaskError", [], UpdateTaskError, () => [[], [], []]);
}

export class CompleteCourseTaskError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TaskNotFound", "CourseNotFound", "UserNotFound"];
    }
}

export function CompleteCourseTaskError_$reflection() {
    return union_type("Shared.Api.CompleteCourseTaskError", [], CompleteCourseTaskError, () => [[], [], []]);
}

export class CompleteTrackLevelTaskError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TaskNotFound", "TrackLevelNotFound", "UserNotFound"];
    }
}

export function CompleteTrackLevelTaskError_$reflection() {
    return union_type("Shared.Api.CompleteTrackLevelTaskError", [], CompleteTrackLevelTaskError, () => [[], [], []]);
}

export class ITaskApi extends Record {
    constructor(GetAllTasks, Get, GetMy, Add, Update, CompleteCourseTask, RevokeCourseTask, CompleteTrackLevelTask, RevokeTrackLevelTask) {
        super();
        this.GetAllTasks = GetAllTasks;
        this.Get = Get;
        this.GetMy = GetMy;
        this.Add = Add;
        this.Update = Update;
        this.CompleteCourseTask = CompleteCourseTask;
        this.RevokeCourseTask = RevokeCourseTask;
        this.CompleteTrackLevelTask = CompleteTrackLevelTask;
        this.RevokeTrackLevelTask = RevokeTrackLevelTask;
    }
}

export function ITaskApi_$reflection() {
    return record_type("Shared.Api.ITaskApi", [], ITaskApi, () => [["GetAllTasks", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Task_$reflection()), GetTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Task_$reflection())]], [["ErrorValue", GetTaskError_$reflection()]]])]))], ["Get", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Task_$reflection(), GetTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", Task_$reflection()]], [["ErrorValue", GetTaskError_$reflection()]]])]))], ["GetMy", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Task_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(Task_$reflection())]], [["ErrorValue", unit_type]]])]))], ["Add", lambda_type(NewTask_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Task_$reflection(), AddTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", Task_$reflection()]], [["ErrorValue", AddTaskError_$reflection()]]])]))], ["Update", lambda_type(int32_type, lambda_type(UpdatedTask_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Task_$reflection(), UpdateTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", Task_$reflection()]], [["ErrorValue", UpdateTaskError_$reflection()]]])])))], ["CompleteCourseTask", lambda_type(int32_type, lambda_type(array_type(int32_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Task_$reflection(), CompleteCourseTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", Task_$reflection()]], [["ErrorValue", CompleteCourseTaskError_$reflection()]]])])))], ["RevokeCourseTask", lambda_type(int32_type, lambda_type(array_type(int32_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, CompleteCourseTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", CompleteCourseTaskError_$reflection()]]])])))], ["CompleteTrackLevelTask", lambda_type(int32_type, lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Task_$reflection(), CompleteTrackLevelTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", Task_$reflection()]], [["ErrorValue", CompleteTrackLevelTaskError_$reflection()]]])])))], ["RevokeTrackLevelTask", lambda_type(int32_type, lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, CompleteTrackLevelTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", CompleteTrackLevelTaskError_$reflection()]]])])))]]);
}

export class AddTrackLevelError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Conflict", "NotFound", "EmptyFields"];
    }
}

export function AddTrackLevelError_$reflection() {
    return union_type("Shared.Api.AddTrackLevelError", [], AddTrackLevelError, () => [[], [], []]);
}

export class UpdateTrackLevelError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Conflict", "NotFound", "EmptyFields"];
    }
}

export function UpdateTrackLevelError_$reflection() {
    return union_type("Shared.Api.UpdateTrackLevelError", [], UpdateTrackLevelError, () => [[], [], []]);
}

export class AddTrackLevelTaskError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Conflict", "NotFound"];
    }
}

export function AddTrackLevelTaskError_$reflection() {
    return union_type("Shared.Api.AddTrackLevelTaskError", [], AddTrackLevelTaskError, () => [[], []]);
}

export class DeleteTrackLevelError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "RelationsExist"];
    }
}

export function DeleteTrackLevelError_$reflection() {
    return union_type("Shared.Api.DeleteTrackLevelError", [], DeleteTrackLevelError, () => [[], []]);
}

export class DeleteTrackLevelTaskError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function DeleteTrackLevelTaskError_$reflection() {
    return union_type("Shared.Api.DeleteTrackLevelTaskError", [], DeleteTrackLevelTaskError, () => [[]]);
}

export class NewTrackLevel extends Record {
    constructor(Name, Description, TrackId) {
        super();
        this.Name = Name;
        this.Description = Description;
        this.TrackId = (TrackId | 0);
    }
}

export function NewTrackLevel_$reflection() {
    return record_type("Shared.Api.NewTrackLevel", [], NewTrackLevel, () => [["Name", string_type], ["Description", string_type], ["TrackId", int32_type]]);
}

export class ITrackLevelApi extends Record {
    constructor(Add, Update, Delete, AddTask, DeleteTask, AddRequiredTask, DeleteRequiredTask) {
        super();
        this.Add = Add;
        this.Update = Update;
        this.Delete = Delete;
        this.AddTask = AddTask;
        this.DeleteTask = DeleteTask;
        this.AddRequiredTask = AddRequiredTask;
        this.DeleteRequiredTask = DeleteRequiredTask;
    }
}

export function ITrackLevelApi_$reflection() {
    return record_type("Shared.Api.ITrackLevelApi", [], ITrackLevelApi, () => [["Add", lambda_type(NewTrackLevel_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [TrackLevel_$reflection(), AddTrackLevelError_$reflection()], FSharpResult$2, () => [[["ResultValue", TrackLevel_$reflection()]], [["ErrorValue", AddTrackLevelError_$reflection()]]])]))], ["Update", lambda_type(TrackLevel_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [TrackLevel_$reflection(), UpdateTrackLevelError_$reflection()], FSharpResult$2, () => [[["ResultValue", TrackLevel_$reflection()]], [["ErrorValue", UpdateTrackLevelError_$reflection()]]])]))], ["Delete", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, DeleteTrackLevelError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", DeleteTrackLevelError_$reflection()]]])]))], ["AddTask", lambda_type(tuple_type(int32_type, int32_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Task_$reflection(), AddTrackLevelTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", Task_$reflection()]], [["ErrorValue", AddTrackLevelTaskError_$reflection()]]])]))], ["DeleteTask", lambda_type(tuple_type(int32_type, int32_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, DeleteTrackLevelTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", DeleteTrackLevelTaskError_$reflection()]]])]))], ["AddRequiredTask", lambda_type(tuple_type(int32_type, int32_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Task_$reflection(), AddTrackLevelTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", Task_$reflection()]], [["ErrorValue", AddTrackLevelTaskError_$reflection()]]])]))], ["DeleteRequiredTask", lambda_type(tuple_type(int32_type, int32_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, DeleteTrackLevelTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", DeleteTrackLevelTaskError_$reflection()]]])]))]]);
}

export class S3Error extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["UploadFailed"];
    }
}

export function S3Error_$reflection() {
    return union_type("Shared.Api.S3Error", [], S3Error, () => [[]]);
}

export class IS3Api extends Record {
    constructor(UploadFile) {
        super();
        this.UploadFile = UploadFile;
    }
}

export function IS3Api_$reflection() {
    return record_type("Shared.Api.IS3Api", [], IS3Api, () => [["UploadFile", lambda_type(S3UploadFile_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, S3Error_$reflection()], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", S3Error_$reflection()]]])]))]]);
}

//# sourceMappingURL=Api.jsx.map
